import { useEffect, useState } from "react";

/**
 * On change, drop the previous value immediately so in-flight work can abort,
 * then publish the new value after `ms` of no further changes.
 */
export function useSettledValue(value, ms = 100) {
  const [source, setSource] = useState(value);
  const [settled, setSettled] = useState(value);

  if (value !== source) {
    setSource(value);
    setSettled(null);
  }

  useEffect(() => {
    if (settled != null || value == null) return undefined;
    const id = window.setTimeout(() => setSettled(value), ms);
    return () => window.clearTimeout(id);
  }, [value, settled, ms]);

  return settled;
}
